import React from 'react';
import classnames from 'classnames';
import { finishPlatingOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const FinishPlating = (props) => {
  const name = 'finish_plating';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
    locked,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('finish-plating', className)}
      disabled={disabled}
      locked={locked} />
  );
};

FinishPlating.defaultProps = {
  label: Spree.translations.parameters.finish_plating,
  options: finishPlatingOptions,
  name: 'finish_plating',
  tooltip: Spree.helpForParameters.finish_plating,
};

export default FinishPlating;
